import { Link } from 'react-router-dom';
import styles from './VendorCard.module.scss';

export default function VendorCard(props) {
    const {data} = props;

  return (
    <vendor-card-item>
        <div className={`${styles.vendorCard} p-3`}>
                {
                    data.products.length > 0 &&
                        <div className={`${styles.vendorProduct} mb-2`}>
                            {
                                data.products.map((item,index) => (
                                    <img src={`${!item.image ? '/images.png' : `${process.env.REACT_APP_API_URL}${item.image}`}`} 
                                        key={index} 
                                        className={`${styles.productImage} img-fluid`} 
                                    />
                                ))
                            }
                        </div>
                }               
            <div className={`${styles.vendorInfo}`}>
                <div className={`${styles.profileImage} me-2`}>
                    <Link 
                        to={`/product-list/?user_id=${data.id}`}
                    >
                        <img
                            src={`${!data.avatar ? '/images.png' : `${process.env.REACT_APP_API_URL}${data.avatar}`}`} 
                            className={`img-fluid`} />
                    </Link>
                </div>
                <div className={`${styles.vendorInfoBox}`}>
                    <Link
                        to={`/product-list/?user_id=${data.id}`}
                        className={`${styles.vendorName} text-decoration-none text-body`}>
                        {data.username}
                    </Link>
                    <div className={`${styles.productsCount}`}>
                        <span>{data.product_count}</span>
                        <span>
                            {
                                data.product_count > 1
                                ? 'items'
                                : 'item'
                            }
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </vendor-card-item>
  )
}
